import * as React from 'react';
import './ChangeActiveProfile.css';
import InvestmentProfileCardComponent from '../partials/InvestmentProfileCard.component';
import Investment from 'src/entities/Investment';
import Person from 'src/entities/Person';
import JuridicalPerson from 'src/entities/JuridicalPerson';

export interface ChangeActiveProfileComponentProps {
  physicalPerson: Person;
  juridicalPersons: JuridicalPerson[];
  handleClick: (index?: number) => void;
  investment: Investment;
  activeProfile: Person;
  defaultProfile: Person;
}

class ChangeActiveProfileComponent extends React.PureComponent<ChangeActiveProfileComponentProps> {

  public ifActive(person: Person): boolean {
      return (person.id === this.props.activeProfile.id &&
          person.personType === this.props.activeProfile.personType);
  }

  public ifDefault(person: Person): boolean {
    return (person.id === this.props.defaultProfile.id &&
        person.personType === this.props.defaultProfile.personType);
  }

  public render(): React.ReactNode {

    return (
      <div className="modal-content investment-funnel-modal change-profile-modal">
        <div className="modal-body">
          <div className="row">
            <p className="featured c-black-text">
              Selecciona tu perfil de inversión
            </p>
            <div className="gap-30"/>
            <InvestmentProfileCardComponent
              name={this.props.physicalPerson.name}
              juridical={false}
              activeProfile={this.ifActive(this.props.physicalPerson)}
              defaultProfile={this.ifDefault(this.props.physicalPerson)}
              onClick={this.props.handleClick}
            />
            {this.props.juridicalPersons.map((juridicalPerson, index) => (
              <InvestmentProfileCardComponent
                key={index}
                ind={index}
                name={juridicalPerson.getName()}
                juridical={true}
                activeProfile={this.ifActive(juridicalPerson)}
                defaultProfile={this.ifDefault(juridicalPerson)}
                onClick={this.props.handleClick}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default ChangeActiveProfileComponent;



// WEBPACK FOOTER //
// ./src/modules/modals/investment-funnel/change-profile/ChangeActiveProfile.component.tsx